import type { DashboardMetric } from '@wlb/shared/api/admin/adminTypes';

/**
 * Finds one per-platform metric row (e.g. Downloads) by key or label,
 * regardless of casing on either side. Undefined when the API did not send
 * that row.
 */
export const findMetric = (
  metrics: readonly DashboardMetric[],
  name: string,
): DashboardMetric | undefined => {
  const target = name.trim().toLowerCase();
  return metrics.find(metric =>
    [metric.metrickey, metric.metricname].some(
      value => value?.trim().toLowerCase() === target,
    ),
  );
};

/**
 * Total of one per-platform metric row (e.g. Downloads). 0 when the API did
 * not send that row — a missing metric must read as zero, never as an error
 * on the dashboard.
 */
export const metricTotal = (
  metrics: readonly DashboardMetric[],
  name: string,
): number => {
  const row = findMetric(metrics, name);
  return row ? row.desktop + row.android + row.ios : 0;
};
